import request from '@/utils/request'

const baseUrl = '/admin'

export const login = (account: string, password: string): Promise<any> => {
    return request.post(`${baseUrl}/administrators/login`, {account, password})
}

export const logout = (): Promise<any> => {
    return request.post(`${baseUrl}/administrators/logout`)
}

export const permissions = (type: string, client: string, code = null) => {
    return request.get(`${baseUrl}/administrators/permissions`, {params: {type, client, code}})
}

export const administrators = (params: any): Promise<any> => {
    return request.get(`${baseUrl}/administrators`, {params})
}

export const createAdministrator = (data: any): Promise<any> => {
    return request.post(`${baseUrl}/administrators`, data)
}

export const updateAdministrator = (id: number, data: any): Promise<any> => {
    return request.put(`${baseUrl}/administrators/${id}`, data)
}
